export enum Permissions {
  Add = "Add",
  Edit = "Edit",
  View = "View",
  ViewAll = "ViewAll",
  Cancel = "Cancel",
  Delete = "Delete",
  Search = "Search",
  Download = "Download",
  ExcelExport = "ExcelExport",
  PdfExport = "PdfExport",
  Collection = "Collection",
  Delivery = "Delivery",
  B2B = "B2B",
  Clearance = "Clearance",
  Replenishment = "Replenishment",
  Kiosk = "Kiosk",
  Report = "Report",
  Controller = "ControllerArea",
  Route = "Route",
  Store = "StoreManagement",
  Vault = "Vault",
  Asset = "Asset",
  Team = "TeamManagement",
  EndOfDay = "EndOfDay",
  OperationWindow = "OperationWindow",
  WorkforceMonitoring = "WorkforceMonitoring",
  VaultHolding = "VaultHolding",
  Maintenance = "Maintenance",
  Handover = "Handover",
  InterBranch = "InterBranch",
}
